/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-05T19:13:41.323
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveRentConsumeMaterialUser,
	getRentConsumeMaterialUserCreateInit,
	getRentConsumeMaterialUserEditInit,
	getRentConsumeMaterialUserView,
	deleteRentConsumeMaterialUser
} from '@api/rentmanage/RentConsumeMaterialUser';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getRentConsumeMaterialUserCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentConsumeMaterialUserCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentConsumeMaterialUserEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentConsumeMaterialUserEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentConsumeMaterialUser({}, RentConsumeMaterialUser) {
			return new Promise((resolve, reject) => {
				saveRentConsumeMaterialUser(RentConsumeMaterialUser)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentConsumeMaterialUserView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentConsumeMaterialUserView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentConsumeMaterialUser({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentConsumeMaterialUser({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
